import $ from 'jquery';
/**
 * @description Animate expansible offcanvas menu
 */ export const init = async function() {
    const allTopLinks = $('.js-offcanvas-nav-top-link');
    const allSubLists = $('.js-offcanvas-nav-sublist');
    const wrapper = $('.js-offcanvas-content');
    // Measure each item list to make CSS animation work
    allSubLists.each(function measureItem(_, element) {
        $(element).addClass('is-hidden');
    });
    allTopLinks.on('click', function(evt) {
        evt.preventDefault();
        const selectedLink = $(evt.delegateTarget);
        const listHandle = selectedLink.attr('data-list-handle') || '';
        if (selectedLink.hasClass('is-expanded')) {
            allTopLinks.removeClass('is-expanded');
            allSubLists.addClass('is-hidden');
            return;
        }
        const selectedList = allSubLists.filter(`[data-list-handle='${listHandle}']`);
        selectedLink.addClass('is-expanded');
        allTopLinks.not(selectedLink).removeClass('is-expanded');
        selectedList.removeClass('is-hidden');
        allSubLists.not(selectedList).addClass('is-hidden');
        wrapper.css('overflow-y', 'scroll');
    });
};
